import { useEffect, useState } from "react";
import { tracking } from '../../utils/tracking';
import { svgs } from "../../assets/svgs";
import sponsors_partners from '../../data/sponsors_partners.json'

export const PartnerCards = () => {
   const [data, setData] = useState([]);

   useEffect(() => {
     setData(sponsors_partners)
   }, []);

   return (
      <div className='partner-cards'>
         <header>
            <p>
               “One of the top events of the year for the invaluable content, presentation quality and opportunities to connect investors and founders.”
            </p>
            <p>
               - Tina Gregory, Early Growth
            </p>
         </header>
         <main >
            {
               data.map((partner, partnerIdx) => {
                  if (partner.sponsor_type === 'industry_partners') return <div key={partnerIdx}></div>
                  // let numOfmembers = JSON.parse(partner.team_members).length
                  return (
                     <div className='partner'>
                        <section className='details'>
                           <h5>{partner.display_name} Partner</h5>
                           <img src={partner.logo_url} alt='logo' />
                           <p>{partner.description}</p>
                           <div className="btn-container">
                              <a className='btn' href={partner.website} target="_blank" rel='noreferrer'>learn more</a>
                           </div>
                        </section>
                        {partner?.members && <section className='members'>
                           {
                              partner.members.map((member, memberIdx) =>
                                 <div className='member' key={member.id}>
                                    <img src={member.headshot_url} alt={member.firstname} />
                                    <h6>{member.firstname} {member.lastname}</h6>
                                    <p>{member.jobtitle}</p>
                                    <a href={member.linkedin} target='_blank' rel='noreferrer'>{svgs.linkedin}</a>
                                 </div>
                              )
                           }
                        </section>}

                     </div>
                  )
               }
               )
            }
         </main>
      </div>
   )
}
